const dateToString = (str: string) => {
  return new Date(str).toLocaleDateString(`en-US`);
};
export default dateToString;
